import { render } from "./ActivePrj.vue?vue&type=template&id=3962414c&scoped=true"
import script from "./ActivePrj.vue?vue&type=script&lang=js"
export * from "./ActivePrj.vue?vue&type=script&lang=js"

import "./ActivePrj.vue?vue&type=style&index=0&id=3962414c&lang=css"
import "./ActivePrj.vue?vue&type=style&index=1&id=3962414c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3962414c"]])

export default __exports__